/** @jsx jsx */
import { jsx, Flex } from "theme-ui";
import { Link as GatsbyLink } from "gatsby";

const BlogPostPagination = ({previous, next}) => {
  return (
    <nav>
      <Flex
        as="ul"
        sx={{
          justifyContent: "space-between",
          listStyle: "none",
          padding: 0,
        }}
      >
        <li sx={{mr: 4}}>
          {next && (
            <GatsbyLink
              to={next.fields.slug}
              rel="next"
              sx={{
                variant: "links.inline",
                display: "block"
              }}
            >
              <Flex sx={{flexDirection: "row", alignItems: "flex-start"}}>
                <span sx={{mr: 2}}>«</span> <span>{next.frontmatter.title}</span>
              </Flex>
            </GatsbyLink>
          )}
        </li>
        <li>
          {previous && (
            <GatsbyLink
              to={previous.fields.slug}
              rel="prev"
              sx={{
                variant: "links.inline",
                display: "block",
                textAlign: "right"
              }}
            >
              <Flex sx={{flexDirection: "row", alignItems: "flex-end"}}>
                <span sx={{mr: 2}}>{previous.frontmatter.title}</span> <span >»</span>
              </Flex>
            </GatsbyLink>
          )}
        </li>
      </Flex>
    </nav>
  );
};

export default BlogPostPagination;
